import { render, staticRenderFns } from "./ProductTechnicalFilterSlider.vue?vue&type=template&id=6afddd81"
import script from "./ProductTechnicalFilterSlider.vue?vue&type=script&lang=js"
export * from "./ProductTechnicalFilterSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductTechnicalFilterSlider.vue?vue&type=style&index=0&id=6afddd81&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports